import { APIWithoutURLBaseAndAuth as API } from './API';

const path = `ufs`;

const UFService = {    
    list: async () => await API.list(`${process.env.REACT_APP_API_MUNICIPIOS_URL}/${path}`),
    validarINEP: async (id) => await API.list(`${process.env.REACT_APP_API_MUNICIPIOS_URL}/${path}/validar-mec/${id}`),
}

export default UFService;